/**
 * Custom event broadcast whenever a successful admin mutation should invalidate
 * HotelContext's cached hotel/user state (e.g. registration completed, hotel
 * profile updated, role/permission change).
 *
 * Producer: `apiClient.ts` response interceptor — dispatches automatically on
 * successful POST/PUT/PATCH/DELETE to `/api/admin/registration/*` or
 * `/api/admin/account/*`. Callers do not need to opt in.
 *
 * Consumer: `HotelContext.tsx` listener — calls `fetchHotelInfo()` +
 * `fetchAvailableHotels()` to refresh React state.
 *
 * NOTE: the refetch triggered by this event is asynchronous. If the caller
 * navigates immediately after the mutation (e.g. `navigate("/admin")`), the
 * next render may still observe stale state for ~1s until the fetch resolves.
 * In timing-critical flows (e.g. NoHotelsPage after first hotel creation),
 * prefer `window.location.href = returnTo` to force a full app rebootstrap.
 */
export const HOTEL_STATE_INVALIDATED_EVENT = "hotelsuite:hotel-state-invalidated";

export interface HotelStateInvalidatedDetail {
  url: string;
  method: string;
}

export function dispatchHotelStateInvalidated(detail: HotelStateInvalidatedDetail): void {
  window.dispatchEvent(
    new CustomEvent<HotelStateInvalidatedDetail>(HOTEL_STATE_INVALIDATED_EVENT, { detail })
  );
}
